import { FilterState } from './ShopifyFilters';

import { IProductIdWithHaggle } from '@/interfaces/api/product/IProductIdWithHaggle';
import { IProductWithHaggle } from '@/interfaces/api/product/IProductWithHaggle';

export const applyFilters = (
	products: (IProductWithHaggle | IProductIdWithHaggle)[],
	filters: FilterState,
) => {
	return products.filter((product) => {
		// Price filter
		const price = Number(product.variants[0]?.price || 0);
		if (price < filters.priceRange.min || price > filters.priceRange.max) {
			return false;
		}

		// Vendor filter
		if (filters.vendor.length && !filters.vendor.includes(product.vendor)) {
			return false;
		}

		// Category filter (previously Product type filter)
		if (
			filters.category.length &&
			!filters.category.includes(product.product_type)
		) {
			return false;
		}

		// Haggle status filter
		if (filters.haggleStatus.length) {
			const now = new Date();
			const hasHaggle = !!product.haggle;
			const isLive =
				hasHaggle &&
				product.haggle &&
				new Date(product.haggle.startDate) <= now &&
				new Date(product.haggle.endDate) >= now;
			const isUpcoming =
				hasHaggle && product.haggle && new Date(product.haggle.startDate) > now;

			const matchesStatus = filters.haggleStatus.some((status) => {
				if (status === 'all') return hasHaggle;
				if (status === 'live') return isLive;
				if (status === 'upcoming') return isUpcoming;
				return false;
			});

			if (!matchesStatus) return false;
		}

		// Country filter
		if (
			filters.country.length &&
			product.store?.country_name &&
			!filters.country.includes(product.store.country_name)
		) {
			return false;
		}

		return true;
	});
};
